var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "__title" }, [
        _vm._v(_vm._s(_vm.$t("settingAcc")))
      ]),
      _vm._v(" "),
      _c("create", { ref: "createDom", attrs: { submit: _vm.createAccount } }),
      _vm._v(" "),
      _c("div", { staticClass: "__btn_list" }, [
        _c(
          "span",
          {
            staticClass: "__btn __btn_border __pointer",
            on: { click: _vm.back }
          },
          [_vm._v("\n            " + _vm._s(_vm.$t("btn.back")) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "__btn __btn_all_in __pointer",
            on: { click: _vm.valid }
          },
          [_vm._v("\n            " + _vm._s(_vm.$t("btn.next")) + "\n        ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }